module.exports = __webpack_public_path__ + "static/media/tab-slurp-chocolatey.82a21ae1.png";